export default "__VITE_ASSET__Dz$M2NNV__"